// extracted by mini-css-extract-plugin
export default {"navLogo":"NavMobile_navLogo__lMjgu","navBar":"NavMobile_navBar__TJmrB","burger":"NavMobile_burger__Vp3Pb","menu":"NavMobile_menu__rrje5"};